import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { KEVALTEK_LOGO, REGISTRATION_OPEN } from "@/data";

const links = [
  { label: "Event", id: "event" },
  { label: "Brands", id: "brands" },
  { label: "Why Visit", id: "manifesto" },
  { label: "Gallery", id: "gallery" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "glass border-b border-white/10" : ""
      }`}
      data-testid="navbar"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-3 md:px-10">
        <a href="/" className="flex items-center gap-3" data-testid="nav-logo">
          <img src={KEVALTEK_LOGO} alt="KevalTek Expo" className="h-10 w-auto md:h-12" />
        </a>

        <nav className="hidden items-center gap-9 md:flex">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              className="font-mono-tech text-xs uppercase tracking-[0.2em] text-muted-foreground transition-colors hover:text-white"
              data-testid={`nav-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          onClick={() => scrollTo(REGISTRATION_OPEN ? "register" : "gallery")}
          className="group relative overflow-hidden rounded-sm bg-orange px-5 py-2.5 font-mono-tech text-xs font-medium uppercase tracking-[0.15em] text-white transition-transform duration-300 hover:-translate-y-0.5"
          data-testid="nav-register-btn"
        >
          {REGISTRATION_OPEN ? "Register Now" : "View Highlights"}
        </button>
      </div>
    </motion.header>
  );
}
